// Content format conversion utilities

/**
 * Check if content is HTML
 */
export function isHtml(content: string): boolean {
  return /<[a-z][\s\S]*>/i.test(content);
}

/**
 * Convert plain text to HTML
 * Preserves paragraphs and line breaks
 */
export function textToHtml(text: string): string {
  if (!text) return '';

  // If already HTML, return as is
  if (isHtml(text)) {
    return text;
  }

  // Split by double newlines for paragraphs
  const paragraphs = text.split(/\n\n+/);

  // Convert each paragraph
  const htmlParagraphs = paragraphs.map((para) => {
    // Replace single newlines with <br>
    const withBreaks = para.replace(/\n/g, '<br>');
    
    // Wrap in paragraph tag
    return `<p>${withBreaks}</p>`;
  });

  return htmlParagraphs.join('');
}

/**
 * Convert HTML to plain text (for preview/search)
 */
export function htmlToText(html: string): string {
  // Remove HTML tags
  const text = html.replace(/<[^>]*>/g, '');
  
  // Decode HTML entities
  const textarea = document.createElement('textarea');
  textarea.innerHTML = text;
  
  return textarea.value;
}

/**
 * Auto-detect and convert URLs to links in HTML
 */
export function autoLinkUrls(html: string): string {
  const urlRegex = /(https?:\/\/[^\s<]+)/g;
  return html.replace(urlRegex, '<a href="$1" target="_blank" rel="noopener noreferrer" class="text-blue-600 hover:text-blue-700 underline">$1</a>');
}

/**
 * Sanitize HTML content (basic sanitization)
 */
export function sanitizeHtml(html: string): string {
  // Remove script tags
  let sanitized = html.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');
  
  // Remove event handlers
  sanitized = sanitized.replace(/on\w+="[^"]*"/gi, '');
  sanitized = sanitized.replace(/on\w+='[^']*'/gi, '');
  
  return sanitized;
}
